import React from 'react';
import classNames from 'classnames';
import { viewTypes } from '../enums';

const LeaderboardRScore = ({ view, toggleRScore }) => {
    const renderContentRScore = () => {
        if (view !== viewTypes.R_SCORE) {
            return (
                <React.Fragment>
                    <div className="leaderboard__cell-r-score-title">round score</div>
                    <div className="leaderboard__cell-r-score-icon-wrapper">
                        <svg className="leaderboard__cell-r-score-icon icon" width="10" height="5" focusable="false">
                            <use xlinkHref="#icon-arrow-down"></use>
                        </svg>
                    </div>
                </React.Fragment>
            );
        }

        return (
            <svg className="leaderboard__cell-r-score-icon icon" width="10" height="10" focusable="false">
                <use xlinkHref="#icon-cross"></use>
            </svg>
        );
    };

    const stateCss = classNames({
        'is-close': view === viewTypes.R_SCORE
    });

    return (
        <button
            className={`leaderboard__cell-r-score ${stateCss}`}
            type="button"
            onClick={toggleRScore}
        >
            <div className="leaderboard__cell-r-score-container">
                {renderContentRScore()}
            </div>
        </button>
    );
};

export default LeaderboardRScore;
